export { default } from './ArticleSlider'
